// GENERATED CODE
// This file is generated by a Python script so do not change it, change the script!
// Script: tools/codegen/generate_error_codes.py
// Template: tools/codegen/templates/error_codes.ts

/** Numeric application error codes carried on `HttpFailure` responses (field `code`). */
export const ErrorCodes = {
  GENERAL_UNSPECIFIED: 0,
  GENERAL_BAD_REQUEST: 40001,
  CASE_WRONG_CLIENT: 40002,
  BANKID_PROCESS_MISSING: 40004,
  LEDGER_BOOK_YEAR_REMOVAL_NOT_BOUNDARY: 40005,
  LEDGER_BOOK_YEAR_UNAVAILABLE: 40006,
  LEDGER_PERIOD_NOT_BOOK_YEAR: 40007,
  LEDGER_UNKNOWN_EXTERNAL_VERSION: 40008,
  INTEGRATION_RECONNECT_REQUIRED: 40009,
  REPORTING_MATERIALITY_LEVELS_NOT_SET: 40010,
  BANKID_SIGNING_ALREADY_IN_PROGRESS: 40011,
  AUTH_HEADER_MISSING: 40012,
  AUTH_HEADER_INVALID: 40013,
  AUTH_TOKEN_INVALID: 40014,
  SIGNING_NO_SIGNEES: 40015,
  SIGNING_DOCUMENT_UNREADABLE: 40016,
  SIGNING_SIGNEE_MISSING_SSN: 40017,
  GENERAL_UNSUPPORTED: 40099,
  AUTH_NO_ACCOUNT: 40102,
  PORTAL_LINK_IDENTITY_MISMATCH: 40103,
  EMPLOYER_ACCOUNT_NOT_CONNECTED: 40104,
  AUTH_TOKEN_EXPIRED: 40106,
  AUTH_SIGN_IN_GONE: 40107,
  WEBHOOK_TIMESTAMP_INVALID: 40197,
  WEBHOOK_SIGNATURE_MALFORMED: 40198,
  WEBHOOK_SIGNATURE_INVALID: 40199,
  GENERAL_FORBIDDEN: 40301,
  AUTH_NOT_AUTHORIZED_FOR_CASE: 40302,
  AUTH_NOT_AUTHORIZED_FOR_CLIENT: 40303,
  AUTH_NOT_AUTHORIZED_FOR_EMPLOYER: 40304,
  AUTH_NOT_AUTHORIZED_FOR_OPERATION: 40305,
  GENERAL_NOT_FOUND: 40401,
  PORTAL_INVITATION_WITHDRAWN: 40402,
  SIGNING_DOCUMENT_MISSING: 40403,
  GENERAL_OPTIMISTIC_LOCK: 40901,
  CASE_ALREADY_EXISTS: 40902,
  CASE_BOOK_YEAR_OVERLAP: 40903,
  PORTAL_NOT_THE_INVITED_PERSON: 40904,
  SIGNING_PROCESS_REMOVED: 40905,
  SIGNING_PROCESS_COMPLETE: 40906,
  SIGNING_NOT_SIGNEES_TURN: 40907,
  SIGNING_CONTENT_HASH_MISMATCH: 40908,
  CASE_HAS_SIGNING_PROCESSES: 40909,
  GENERAL_TOO_MANY_REQUESTS: 42901,
  GENERAL_BUG: 50001,
  BANKID_QR_RENDER_FAILED: 50002,
  GENERAL_CORRUPT_DATABASE: 50101,
  GENERAL_PANIC: 50102,
  GENERAL_UNEXPECTED: 50103,
  GENERAL_UNHANDLED: 50104,
  GENERAL_BAD_GATEWAY: 50201,
  INTEGRATION_UPSTREAM_UNAVAILABLE: 50202,
  GENERAL_TIMEOUT: 50401,
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];

/** `message` is what to show; `action` is the recovery hint, present only where the
 * registry defines one. */
export type ErrorCodeCopyEntry = {
  message: string;
  action?: string;
};

/** Registry copy for every code in `ErrorCodes`, keyed numerically because a failure
 * response can carry a code this client does not know. A call site with richer context
 * (a company name, a book year) should prefer its own wording. */
export const ErrorCodeCopy: Partial<Record<number, ErrorCodeCopyEntry>> = {
  0: {
    message: 'Ett oväntat fel uppstod',
  },
  40001: {
    message: 'Ogiltig begäran',
  },
  40002: {
    message: 'Uppdraget tillhör inte den här klienten',
  },
  40004: {
    message: 'BankID-sessionen kunde inte hittas',
  },
  40005: {
    message: 'Endast det första eller sista räkenskapsåret kan tas bort',
  },
  40006: {
    message: 'Räkenskapsåret finns inte för klienten',
  },
  40007: {
    message: 'Perioden är inte ett räkenskapsår',
  },
  40008: {
    message: 'Extern bokföring är inte synkroniserad',
  },
  40009: {
    message: 'Anslutningen till bokföringssystemet behöver förnyas',
    action: 'Återanslut ditt bokföringssystem och försök igen',
  },
  40010: {
    message: 'Väsentlighetsnivåer måste anges innan rapporteringsunderlag kan tas fram',
    action: 'Ange väsentlighetsnivåer för uppdraget först',
  },
  40011: {
    message: 'En signering pågår redan för den här personen',
    action: 'Slutför signeringen i BankID-appen, eller vänta en stund och försök igen',
  },
  40012: {
    message: 'Ogiltig begäran',
  },
  40013: {
    message: 'Ogiltig begäran',
  },
  40014: {
    message: 'Ogiltig begäran',
  },
  40015: {
    message: 'Ingen har valts som ska signera',
    action: 'Välj minst en person som ska signera och försök igen',
  },
  40016: {
    message: 'Filen kunde inte läsas',
    action: 'Kontrollera att du valt rätt fil och försök igen',
  },
  40017: {
    message: 'Personen saknar personnummer',
    action: 'Komplettera personens uppgifter och försök igen',
  },
  40099: {
    message: 'Funktionen stöds inte',
  },
  40102: {
    message: 'Det finns inget konto kopplat till den här inloggningen',
  },
  40103: {
    message: 'Länken gäller inte för personen du valde',
    action: 'Öppna länken igen och välj en av de personer som visas',
  },
  40104: {
    message: 'Ditt konto är inte kopplat till den här byrån',
  },
  40106: {
    message: 'Din session har gått ut',
    action: 'Logga in igen',
  },
  40107: {
    message: 'Din inloggning har upphört',
    action: 'Logga in igen',
  },
  40197: {
    message: 'Obehörig åtkomst',
  },
  40198: {
    message: 'Obehörig åtkomst',
  },
  40199: {
    message: 'Obehörig åtkomst',
  },
  40301: {
    message: 'Åtkomst nekad',
  },
  40302: {
    message: 'Du har inte behörighet till det här uppdraget',
  },
  40303: {
    message: 'Du har inte behörighet till den här uppdragsgivaren',
  },
  40304: {
    message: 'Du har inte behörighet till den här byrån',
  },
  40305: {
    message: 'Du har inte behörighet till den här åtgärden',
  },
  40401: {
    message: 'Hittades inte',
  },
  40402: {
    message: 'Inbjudan är inte längre giltig',
    action: 'Be din revisionsbyrå skicka en ny inbjudan',
  },
  40403: {
    message: 'Dokumentet kunde inte hittas',
  },
  40901: {
    message: 'Uppgifterna har ändrats, ladda om sidan och försök igen',
  },
  40902: {
    message: 'Ett uppdrag finns redan för det räkenskapsåret',
  },
  40903: {
    message: 'Räkenskapsåret överlappar ett befintligt räkenskapsår',
  },
  40904: {
    message: 'Legitimeringen gäller inte den person som blev inbjuden',
    action: 'Kontakta din revisionsbyrå, som behöver rätta uppgifterna om personen',
  },
  40905: {
    message: 'Signeringen har avbrutits',
    action: 'Ladda om sidan för att se aktuell status',
  },
  40906: {
    message: 'Dokumentet är redan färdigsignerat',
    action: 'Ladda om sidan för att se det signerade dokumentet',
  },
  40907: {
    message: 'Personen kan inte signera ännu',
    action: 'Signeringen sker i turordning, invänta att föregående steg blir klart',
  },
  40908: {
    message: 'Dokumentet har ändrats sedan signeringen påbörjades',
    action: 'Signeringen behöver göras om',
  },
  40909: {
    message: 'Signeringsdata finns kvar och måste raderas innan borttagningen kan göras',
  },
  42901: {
    message: 'För många förfrågningar, försök igen om en stund',
  },
  50001: {
    message: 'Ett internt fel uppstod',
  },
  50002: {
    message: 'QR-koden kunde inte visas',
    action: 'Öppna BankID-appen på den här enheten i stället, eller försök igen',
  },
  50101: {
    message: 'Databasfel',
  },
  50102: {
    message: 'Ett internt fel uppstod',
  },
  50103: {
    message: 'Ett oväntat fel uppstod',
  },
  50104: {
    message: 'Ett oväntat fel uppstod',
  },
  50201: {
    message: 'Kommunikationsfel',
  },
  50202: {
    message: 'Bokföringssystemet är inte tillgängligt just nu',
    action: 'Försök igen om en stund',
  },
  50401: {
    message: 'Tidsgränsen överskreds',
    action: 'Försök igen om en stund',
  },
};

/** The registry's copy for `code` as one string, for surfaces with no separate slot for
 * the action. `undefined` when the code is not in the registry. */
export function errorCodeCopyText(code: number): string | undefined {
  const copy = ErrorCodeCopy[code];
  if (copy === undefined) {
    return undefined;
  }

  return [copy.message, copy.action].filter((part) => part !== undefined).join('. ');
}
